<ng-container *ngIf="page && brConfig?.fundId; else previewBlock">
  <div class="FT-blocks-nav sticky-top hello">
    <ul> <!--TODO :  this has to be modified later on once we have dedicated siteconfig for en-in-new-->
      <li *ngIf="listOfTabs.indexOf('overview') > -1">
        <a class="as-anchor analytics-link overview active-item"
           (click)="scrollTo('overview')">{{ "products.tab-overview" | translate }}
        </a>
      </li>
      <li *ngIf="listOfTabs.indexOf('performance') > -1">
        <a class="as-anchor analytics-link performance"
           (click)="scrollTo('performance')">{{ "products.tab-performance" | translate }}
        </a>
      </li>
      <li *ngIf="listOfTabs.indexOf('portfolio')> -1">
        <a class="as-anchor analytics-link portfolio"
           (click)="scrollTo('portfolio')">{{ "products.tab-portfolio" | translate }}
        </a>
      </li>
      <li *ngIf="listOfTabs.indexOf('documents')> -1">
        <a class="as-anchor analytics-link more-details"
           (click)="scrollTo('more-details')">{{ "products.tab-documents" | translate }}
        </a>
      </li>
    </ul>
  </div>
</ng-container>
<ng-template #previewBlock>
  <h5 *ngIf="page && page.isPreview()">
    Fund Content - Fund Tabs Component
  </h5>
</ng-template>
